import React from "react";
import "./TableListSkeleton.css";

const TableListSkeleton = ({
  rows = 8,
  columns = 6,
  showHeader = true,
  className = "",
  style = {},
}) => {
  const widthPattern = ["88%", "72%", "64%", "80%", "56%", "76%"];

  return (
    <div
      className={`table-list-skeleton ${className}`.trim()}
      style={style}
      aria-hidden="true"
    >
      <table className="table-list-skeleton__table">
        {showHeader && (
          <thead>
            <tr>
              {Array.from({ length: columns }).map((_, index) => (
                <th key={`head-${index}`}>
                  <span className="table-list-skeleton__bar table-list-skeleton__bar--header" />
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={`row-${rowIndex}`}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={`cell-${rowIndex}-${colIndex}`}>
                  <span
                    className="table-list-skeleton__bar"
                    style={{
                      width: widthPattern[(rowIndex + colIndex) % widthPattern.length],
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableListSkeleton;
